import { useState, useEffect } from "react";
import { fetchData } from "../../../../GlobalFunctions";
import { ImSpinner } from "react-icons/im";
import GaugeChart from "react-gauge-chart";
import boxMind from "../../../../../Assets/boxMind_transparent.png";

function TeacherDashboard() {
  interface Dashboard {
    average_quiz_score: string;
    courses_data: {
      description: string;
      difficulty: string;
      id: string;
      level_description: string;
      level_id: string;
      level_name: string;
      name: string;
      price: string;
    };
    school_name: string;
    courses_number: string;
    student_level: string;
    student_level_name: string;
    max_input_tokens_per_day: number;
    max_output_tokens_per_day: number;
    input_tokens_today: number;
    output_tokens_today: number;
    sst_max_minutes_per_day: number;
    total_sst_minutes_today: number;
    tts_max_characters_per_day: number;
    total_tts_characters_today: number;
    role_name: string;
    teacher_levels: string[];
  }

  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState<Dashboard>();

  const [inputPercent, setInputPercent] = useState<number>(0);
  const [outputPercent, setOutputPercent] = useState<number>(0);
  const [ttsPercent, setTtsPercent] = useState<number>(0);
  const [sttPercent, setSttPercent] = useState<number>(0);

  useEffect(() => {
    fetchData(
      `${process.env.REACT_APP_API}${process.env.REACT_APP_DASHBOARD_DATA}`,
      setDashboardData
    );
  }, []);

  useEffect(() => {
    if (dashboardData?.input_tokens_today !== undefined) {
      setInputPercent(
        isNaN(
          (dashboardData?.input_tokens_today ?? 0) /
            (dashboardData?.max_input_tokens_per_day ?? 0)
        )
          ? 0
          : dashboardData?.input_tokens_today /
              dashboardData?.max_input_tokens_per_day
      );
    }
    if (dashboardData?.output_tokens_today !== undefined) {
      setOutputPercent(
        isNaN(
          (dashboardData?.output_tokens_today ?? 0) /
            (dashboardData?.max_output_tokens_per_day ?? 0)
        )
          ? 0
          : dashboardData?.output_tokens_today /
              dashboardData?.max_output_tokens_per_day
      );
    }
    if (dashboardData?.total_sst_minutes_today !== undefined) {
      setSttPercent(
        isNaN(
          (dashboardData?.total_sst_minutes_today ?? 0) /
            (dashboardData?.sst_max_minutes_per_day ?? 0)
        )
          ? 0
          : dashboardData?.total_sst_minutes_today /
              dashboardData?.sst_max_minutes_per_day
      );
    }
    if (dashboardData?.total_tts_characters_today !== undefined) {
      setTtsPercent(
        isNaN(
          (dashboardData?.total_tts_characters_today ?? 0) /
            (dashboardData?.tts_max_characters_per_day ?? 0)
        )
          ? 0
          : dashboardData?.total_tts_characters_today /
              dashboardData?.tts_max_characters_per_day
      );
    }
    setLoading(false);
  }, [dashboardData]);

  if (loading) {
    return (
      <div className="flex justify-center mt-10">
        <ImSpinner size={30} className=" animate-spin" />
      </div>
    );
  }

  console.log(dashboardData?.role_name);

  return (
    <section
      className="overflow-scroll h-screen"
      style={{ maxHeight: "calc(100vh - 50px)" }}
    >
      <div className="lg:grid lg:grid-cols-10 ">
        <div className=" flex flex-col gap-3 justify-between col-span-3 p-4">
          {dashboardData?.role_name === "student" && (
            <div className=" flex flex-col items-center justify-center ">
              <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#9665FF]">
                <div>
                  You are enrolled in {dashboardData?.courses_number} courses!
                </div>
                <div className="w-full flex justify-center">
                  <div
                    onClick={() => (window.location.href = "/courses")}
                    className="bg-white text-[#4D30B5] p-2 rounded-md text-[15px]  text-center w-fit mt-5 cursor-pointer mb-2 hover:bg-gray-200 duration-300"
                  >
                    View Courses
                  </div>
                </div>
              </div>
            </div>
          )}
          {(dashboardData?.role_name === "teacher" ||
            dashboardData?.role_name === "schooladmin" ||
            dashboardData?.role_name === "employee") &&
            dashboardData?.teacher_levels && (
              <div className=" flex flex-col items-center justify-center">
                <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#9665FF]">
                  <p>You are a {dashboardData?.role_name} in</p>
                  {dashboardData.teacher_levels.join(", ")}
                </div>
              </div>
            )}
          <div className=" flex flex-col items-center justify-center ">
            <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#4AD4F0]">
              <div>Input Tokens Used:</div>
              <div>
                {dashboardData?.input_tokens_today}/
                {dashboardData?.max_input_tokens_per_day}
              </div>
              <GaugeChart
                id="gauge-chart2"
                nrOfLevels={20}
                percent={inputPercent}
              />
            </div>
          </div>
          <div className=" flex flex-col items-center justify-center ">
            <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#4AD4F0]">
              <div>Output Tokens Used:</div>
              <div>
                {dashboardData?.output_tokens_today}/
                {dashboardData?.max_output_tokens_per_day}
              </div>
              <GaugeChart
                id="gauge-chart2"
                nrOfLevels={20}
                percent={outputPercent}
              />
            </div>
          </div>
        </div>
        <div className=" col-span-4 p-10 h-full flex flex-col justify-center">
          {dashboardData?.role_name === "schooladmin" && (
            <div className=" flex flex-col items-center justify-center ">
              <div className="flex flex-col text-center justify-center font-bold text-[25px] w-full p-2 rounded-lg text-[#135991]">
                you are registered to {dashboardData?.school_name} school.
              </div>
            </div>
          )}
          <img src={boxMind} alt="boxMind" />
        </div>

        <div className=" flex flex-col gap-3 justify-between col-span-3 p-4">
          {dashboardData?.role_name === "student" && (
            <div className=" flex flex-col items-center justify-center ">
              <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#FF8144]">
                <div>
                  You have an average quiz score of{" "}
                  {dashboardData?.average_quiz_score} / 100
                </div>
                <div className="w-full flex justify-center">
                  <div
                    onClick={() => (window.location.href = "/quizzes")}
                    className="bg-white text-[#4D30B5] p-2 rounded-md text-[15px]  text-center w-fit mt-5 cursor-pointer mb-2 hover:bg-gray-200 duration-300"
                  >
                    View Quizzes
                  </div>
                </div>
              </div>
            </div>
          )}
          {dashboardData?.role_name !== "schooladmin" && (
            <div className=" flex flex-col items-center justify-center ">
              <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#FF8144]">
                you are registered to {dashboardData?.school_name} school.
              </div>
            </div>
          )}

          <div className=" flex flex-col items-center justify-center ">
            <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#F4B4D3]">
              <div>TTS Characters Used:</div>
              <div>
                {dashboardData?.total_tts_characters_today}/
                {dashboardData?.tts_max_characters_per_day}
              </div>
              <GaugeChart
                id="gauge-chart2"
                nrOfLevels={20}
                percent={ttsPercent}
              />
            </div>
          </div>
          <div className=" flex flex-col items-center justify-center ">
            <div className="flex flex-col text-center justify-center font-semibold text-[20px] w-full p-2 rounded-lg text-white bg-[#F4B4D3]">
              <div>STT Minutes Used:</div>
              <div>
                {dashboardData?.total_sst_minutes_today?.toFixed(2)}/
                {dashboardData?.sst_max_minutes_per_day}
              </div>
              <GaugeChart
                id="gauge-chart2"
                nrOfLevels={20}
                percent={sttPercent}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeacherDashboard;
